import { render, staticRenderFns } from "./OnboardingProfileSchedule.vue?vue&type=template&id=bbcdd5d4&"
import script from "./OnboardingProfileSchedule.vue?vue&type=script&lang=js&"
export * from "./OnboardingProfileSchedule.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingProfileSchedule.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
